/* eslint-disable react/prop-types */
import React, { useEffect, useCallback, useState } from 'react';

import { Col, Row, Radio } from 'antd';

import ErrorField from '~/components/ErrorField';

import { BoxInput, Label, BoxRadios } from '../../styles/style';
import ButtonReset from '../ButtonReset';

export function RadioInput({ item, formik, reset, wideLabel }) {
  const [divStyle, setDivStyle] = useState({ minHeight: '38px' });

  // Reset Button
  const [isLoaded, setIsloaded] = useState(false);

  const handleResetGroup = useCallback(
    group => {
      group.map(groupItem => {
        formik.setFieldValue(`${groupItem.name}`, null);
      });
    },
    [formik]
  );

  useEffect(() => {
    if (reset || wideLabel) {
      setDivStyle({
        minHeight: '38px',
        width: '767px',
      });
    }
    setTimeout(() => {
      setIsloaded(true);
    }, 2000);
  }, [wideLabel, reset]);

  // End Reset Button
  return (
    <BoxInput key={item.id}>
      <Row>
        <div style={divStyle}>
          <Row>
            <Col span={24}>
              <Col span={reset ? 12 : 22}>
                <Label style={{ minHeight: '32px' }}>{item.label}</Label>
              </Col>
              <Col span={12}>
                {reset && isLoaded && (
                  <ButtonReset
                    resetGroup={[item]}
                    handleResetGroup={handleResetGroup}
                  />
                )}
              </Col>
            </Col>
          </Row>
        </div>
        {item.itens &&
          item.itens.map(linha => (
            <Label
              style={{
                marginLeft: '10px',
                color: '#898989',
              }}
              key={linha.id}
            >
              {linha.descricao}
              <br />
            </Label>
          ))}
        <div className="inlineRadiosInput">
          {item.opcoes.map(opcao => (
            <BoxRadios
              key={opcao.id}
              active={formik.values[item.name] === opcao.value}
            >
              <Radio
                name={item.name}
                value={formik.values[opcao.value]}
                checked={formik.values[item.name] === opcao.value}
                onChange={() =>
                  formik.setFieldValue(`${item.name}`, opcao.value)
                }
              >
                {opcao.descricao}
              </Radio>
            </BoxRadios>
          ))}
        </div>
        {formik.errors[item.name] && formik.submitCount > 0 ? (
          <ErrorField message={formik.errors[item.name]} />
        ) : null}
      </Row>
    </BoxInput>
  );
}

//  SEGUNDO INPUT

export function RadioInputFlex({ item, formik, noButton }) {
  // Reset Button
  const [isLoaded, setIsloaded] = useState(false);

  const handleResetGroup = useCallback(
    group => {
      group.map(groupItem => {
        formik.setFieldValue(`${groupItem.name}`, null);
      });
    },
    [formik]
  );

  useEffect(() => {
    setTimeout(() => {
      setIsloaded(true);
    }, 2000);
  }, []);

  // End Reset Button
  return (
    <BoxInput key={item.id}>
      <div className="w-100">
        <div style={{ minHeight: '38px' }}>
          <Row>
            <Col span={12}>
              <Label>{item.label}</Label>
            </Col>
            <Col span={12}>
              {!noButton && isLoaded && (
                <ButtonReset
                  resetGroup={[item]}
                  handleResetGroup={handleResetGroup}
                />
              )}
            </Col>
          </Row>
        </div>
        {item.itens &&
          item.itens.map(linha => (
            <Label
              style={{
                marginLeft: '10px',
                color: '#898989',
              }}
              key={linha.id}
            >
              {linha.descricao}
              <br />
            </Label>
          ))}

        <div className="flexRadiosInput">
          {item.opcoes.map(opcao => (
            <BoxRadios
              key={opcao.id}
              active={formik.values[item.name] === opcao.value}
            >
              <Radio
                name={item.name}
                value={formik.values[opcao.value]}
                checked={formik.values[item.name] === opcao.value}
                onChange={() =>
                  formik.setFieldValue(`${item.name}`, opcao.value)
                }
              >
                {opcao.descricao}
              </Radio>
            </BoxRadios>
          ))}
        </div>

        {formik.errors[item.name] && formik.submitCount > 0 ? (
          <ErrorField message={formik.errors[item.name]} />
        ) : null}
      </div>
    </BoxInput>
  );
}
